module.exports = __webpack_public_path__ + "img/om_inter_ring.cb4f231e.png";